export default __webpack_public_path__ + "ui/assets/img/balance-white-20.svg";